 <!-- eslint-disable vue/no-v-html -->
<script lang="ts" setup>
import type { SectionsRichTextColumnsEmbed } from '@autobid/strapi-integration/rest/components'
import StrapiImage from '@autobid/ui/components/common/strapi/Image.vue'
import { computed } from 'vue'

interface Props {
  data: SectionsRichTextColumnsEmbed
}

const props = defineProps<Props>()

const imageWidthClass = computed(() => {
  if (props.data.type !== 'image' || !props.data.richtext?.width)
    return

  switch (props.data.richtext.width) {
    case 'w-1/2':
      return 'md:w-1/2'
    case 'w-1/3':
      return 'md:w-2/3'
    case 'w-1/4':
      return 'md:w-3/4'
    case 'w-1/6':
      return 'md:w-5/6'
    case 'w-2/3':
      return 'md:w-1/3'
    default:
      return 'w-full'
  }
})
</script>

<template>
  <div
    class="flex md:flex-wrap gap-y-6"
    :class="{
      'md:flex-row': data.textAlign === 'left',
      'md:flex-row-reverse': data.textAlign === 'right',
      'flex-wrap-reverse': data.mobileMediaPosition === 'top',
      'flex-wrap': data.mobileMediaPosition === 'bottom',
      'justify-end': data.alignedContent?.name === 'right',
      'justify-center': data.alignedContent?.name === 'center',
    }"
  >
    <!--
      todo: remove the "!mx-0" class after the strapi ugrade
      see the context: https://gitlab-p2.autobid.de/autobid/autobid-front/autobid-apps/-/merge_requests/1341#note_83828
    -->
    <SectionsRichTextCkeditor v-if="data.richtext" :data="data.richtext" class="!mx-0" />

    <SectionsGoogleMaps
      v-if="data.type === 'map' && data.map"
      :data="data.map"
      is-embeded
    />

    <SectionsVideoPlayer
      v-else-if="data.type === 'video' && data.video"
      :data="data.video"
      is-embeded
    />

    <div
      v-else-if="data.type === 'image' && data.image?.url"
      class="w-full px-3 xl:pl-0"
      :class="imageWidthClass"
    >
      <StrapiImage :data="data.image" />
    </div>
  </div>
</template>
